import "./StyleCarouselBtn.css";
import type React from "react";

type PropsHijo = { children: React.ReactNode };

export const HomeCarouselButton: React.FC<PropsHijo> = ({
  children,
}: PropsHijo) => {
  return (
    <div className="btn-container-main">
      <div className="p-1">{children}</div>
    </div>
  );
};

/*
1----
<div className="btn-container">
      <div className="btn-content">
        <div className="btn-content-box bg-primary p-2 mb-2">
          <button className="ps-btn btn btn-outline-secondary rounded-pill bg-transparent shadow arouselHome">
            <span className="d-flex justify-content-center align-items-center owl-nav">
              Historial de botones 1
            </span>
          </button>
          <button className="ps-btn btn btn-outline-secondary rounded-pill bg-transparent shadow arouselHome">
            <span className="d-flex justify-content-center align-items-center owl-nav">
              Historial de botones 2
            </span>
          </button>
          <button className="ps-btn btn btn-outline-secondary rounded-pill bg-transparent shadow arouselHome">
            <span className="d-flex justify-content-center align-items-center owl-nav">
              Historial de botones 3
            </span>
          </button>
          <button className="ps-btn btn btn-outline-secondary rounded-pill bg-transparent shadow arouselHome">
            <span className="d-flex justify-content-center align-items-center owl-nav">
              Historial de botones 4
            </span>
          </button>
          <button className="ps-btn btn btn-outline-secondary rounded-pill bg-transparent shadow arouselHome">
            <span className="d-flex justify-content-center align-items-center owl-nav">
              Historial de botones 5
            </span>
          </button>
          <button className="ps-btn btn btn-outline-secondary rounded-pill bg-transparent shadow arouselHome">
            <span className="d-flex justify-content-center align-items-center owl-nav">
              Historial de botones 6
            </span>
          </button>
          <button className="ps-btn btn btn-outline-secondary rounded-pill bg-transparent shadow arouselHome">
            <span className="d-flex justify-content-center align-items-center owl-nav">
              Historial de botones 7
            </span>
          </button>
          <button className="ps-btn btn btn-outline-secondary rounded-pill bg-transparent shadow arouselHome">
            <span className="d-flex justify-content-center align-items-center owl-nav">
              Historial de botones 8
            </span>
          </button>
        </div>
      </div>
    </div>
////////////////
2---
<div className="btn-container-main bg-primary">
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
      <div className="btn-content-child">        
      </div>
    </div>
  ///////////////

*/
